import type { CommunityListGlobal, Profile } from 'models';

import { canManageCommunityProfile } from './can-manage-community';

// TODO Assets will be not only in community
export const canManageAssets = ({ community, viewer }: { community: CommunityListGlobal; viewer: Profile }) =>
  canManageCommunityProfile({ community, viewer });
